/** Bucket the in-office count into 4 quartiles for the cell-level
 *  busy bar. Same thresholds as the legacy build so admins keep their
 *  intuition for "is the office full today?". */
export function busynessClass(inOffice: number, total: number): string {
  if (!total || inOffice <= 0) return "";
  const pct = inOffice / total;
  if (pct < 0.25) return "busy-q1";
  if (pct < 0.5) return "busy-q2";
  if (pct < 0.75) return "busy-q3";
  return "busy-q4";
}
